import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import { approveLinkedInUserAPI, fetchToken, sendEmailVerificationStatusAPI } from "../../API/API";
import { getCookie, setCookie } from "../../shared/helpers";

function* authSaga(action) {
  yield put({ type: types.UPDATE_USER_INFO_SUCCESS, payload: action.payload });
}

// catches the action before going to the reducer and run the saga attached to it
export function* watchAuthSaga() {
  yield takeEvery(types.UPDATE_USER_INFO_INIT, authSaga);
}

// Linked In Saga

function* linkedInSaga(action) {
  try {
    const response = yield call(() => approveLinkedInUserAPI(action.payload)); // API Backend
    setCookie("token", response.data.token);
    if (response.data.token) {
      window.location.replace('/auth')
    }
    yield put({
      type: types.UPDATE_USER_INFO_SUCCESS,
      payload: response.data.token,
    });
  } catch (error) {
    yield put({
      type: types.LINKEDIN_TOKEN_FAIL,
      error: error,
    });
  }
  // yield put({ type: types.LINKEDIN_TOKEN_FETCH, payload: action.payload });
}

function* sendEmailVerificationSaga(action) {
  console.log("Saga emailVerification: ", action.payload);
  try {
    const response = yield call(() =>
      sendEmailVerificationStatusAPI(action.payload)
    ); // API Backend
    console.log("emailVerification API RESPONSE: ", response);
    // yield put(getEmailVerificationStatusSuccess(response?.data?.data));
  } catch (error) {
    console.log("emailVerification ERROR RESPONSE", error.response);
    // yield put(getEmailVerificationStatusFailure(response?.data?.data));
  }
  // yield put({ type: types.LINKEDIN_TOKEN_FETCH, payload: action.payload });
}

export function* watchLinkedInSaga() {
  yield takeEvery(types.LINKEDIN_TOKEN_INIT, linkedInSaga);
}

export function* watchSendEmailVerificationSaga() {
  yield takeLatest(
    types.SEND_EMAIL_VERIFICATION_INIT,
    sendEmailVerificationSaga
  );
}